import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import { createContext } from 'react';

export const CKEditorContext = createContext<Editor | undefined>(undefined);
